export default [
  {
    path: '/sales/shop',
    name: 'sales.shop',
    meta: {
      authRequired: true
    },
    component: () => import('@/router/views/sales/shop/index')
  },
  {
    path: '/sales/shop/:id',
    name: 'sales.shop.product',
    meta: {
      authRequired: true
    },
    props: route => ({
      productId: route.params.id
    }),
    component: () => import('@/router/views/sales/shop/product-detail')
  }
]
